// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"351":"60bb7038","895":"9706aacd","925":"da4e9e09"}[chunkId] + ".chunk.css");